<template>
  <main class="page-consultants-create py-5">
    <div class="container">
      <AwlCard>
        <AccountForm :user="user">
          <template v-slot:title>
            Nuovo Supervisor
          </template>
        </AccountForm>
      </AwlCard>
    </div>
  </main>
</template>

<script>
export default {
  name: 'page-consultants-create',
  components: {
    AwlCard: () => import('../../../components/Layout/Card/AwlCard'),
    AccountForm: () => import('../../../components/Account/AccountForm'),
  },
  data () {
    return {
      user: { role: 'consultant' },
    };
  },
};

</script>

<style lang="scss">
  .page-consultants-create {
    .awl-card {
      margin: 0 auto;
      max-width: 750px;
    }
  }
</style>
